<div class="app-field">
  <span class="app-field__label" [id]="controlId() + '-label'">{{ label() }}</span>
  <button #trigger type="button" class="app-multiselect__trigger"
    [disabled]="disabled() || !options().length"
    [attr.aria-expanded]="isOpen()" [attr.aria-controls]="controlId() + '-options'"
    [attr.aria-labelledby]="controlId() + '-label ' + controlId() + '-value'"
    (click)="toggle()">
    <span class="app-multiselect__value" [id]="controlId() + '-value'">
      @if (selectedOptions().length) {
        <span class="app-multiselect__name">{{ selectedOptions()[0].label }}</span>
        @if (selectedOptions().length > 1) {
          <span class="app-multiselect__count">+{{ selectedOptions().length - 1 }}</span>
        }
      } @else {
        <span class="app-multiselect__name">{{ placeholder() }}</span>
      }
    </span>
    <span class="fa-solid" [class.fa-chevron-down]="!isOpen()" [class.fa-chevron-up]="isOpen()" aria-hidden="true"></span>
  </button>
</div>
@if (isOpen()) {
  <div class="app-action-menu app-multiselect__panel" [id]="controlId() + '-options'" role="group" [attr.aria-labelledby]="controlId() + '-label'">
    <label class="app-action-menu__item app-multiselect__option app-multiselect__all">
      <input type="checkbox" [checked]="allSelected()" [indeterminate]="partiallySelected()" (change)="toggleAll()" />
      <span>{{ i18n.t('common.multiselect.selectAll') }}</span>
      <span class="app-multiselect__total">{{ selectedOptions().length }} / {{ options().length }}</span>
    </label>
    <div class="app-action-menu__separator" aria-hidden="true"></div>
    <div class="app-multiselect__options">
      @for (option of options(); track option.value) {
        <label class="app-action-menu__item app-multiselect__option" [class.app-multiselect__option--selected]="selectedSet().has(option.value)">
          <input type="checkbox" [checked]="selectedSet().has(option.value)" (change)="toggleOption(option.value)" />
          <span>{{ option.label }}</span>
        </label>
      }
    </div>
  </div>
}
